export default {
  sideBarToggle({ commit }) {
    commit('updateSidebarState');
  }
}


// WEBPACK FOOTER //
// ./app/resource/global/store/actions.js